import Page from "../pages/Page";
import "~/globals";
import { getApi } from "~/auth";
import UI from "~/ui";
import $ from "jquery";
import { gotoLogin, returnUrl } from "~/utils";
import { InitMap, InitMapPoi } from "~/pages/schedavendita/MapUtils";
import { InitServiziMappa } from "~/pages/schedavendita/ServiziMappaScheda";
import { AddVenditaSeguita, RemoveVenditaSeguita } from "~/pages/schedavendita/VenditaSeguita";
import { handleDownloadDoc } from "~/pages/schedavendita/Documenti";
import { shareOnFacebook } from "~/socialFacebook";
import { initAllSwipers } from "~/pages/schedavendita/SwiperManager";
import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import QRCode from "qrcode";
import { t } from "~/hooks/useI18n";

import { SchedaVenditaState } from "~/pages/schedavendita/SchedaVenditaState";
import { AstaTelematicaManager } from "~/pages/schedavendita/AstaTelematicaManager";
import { AstaDinamicaManager } from "~/pages/schedavendita/AstaDinamicaManager";
import { FormContattiManager, FormContattiConfig } from "~/pages/schedavendita/FormContattiManager";
import { initAccordionDatiCatastali } from "~/pages/schedavendita/AccordionDatiCatastali";

/**
 * Orchestrator della pagina Scheda Vendita.
 * Delega la logica ai manager dedicati (Asta Telematica, Asta Dinamica, Form contatti).
 * Contiene solo pageStart() e le utility di pagina (QR, share, sticky, comparison slider).
 */
export default class SchedaVendita extends Page {
    private state = new SchedaVenditaState();
    private atManager: AstaTelematicaManager | null = null;
    private adManager: AstaDinamicaManager | null = null;

    constructor() {
        super("schedavendita", "Scheda Vendita");
    }

    async pageStart(): Promise<void> {
        returnUrl(window.location.href);

        this.state.readFromDom(getApi());

        this.wireButtons();

        initAllSwipers();
        this.initImageComparisonSliders();

        if (!this.state.aggiudicato && !this.state.venduto) {
            if (this.state.IdAstaTelematica > 0) {
                this.atManager = new AstaTelematicaManager(this.state);
                const _ = this.spinner.spin();
                try {
                    await this.atManager.init();
                } catch (error) {
                    console.error("Errore durante il caricamento iniziale dell'Asta Telematica:", error);
                } finally {
                    this.spinner.stop();
                }
                this.atManager.startPolling();
            } else {
                this.adManager = new AstaDinamicaManager(this.state);
                await this.adManager.init();
            }
        }

        Fancybox.bind('[data-fancybox="galleryFoto"]', {
            // Your custom options
        });

        await this.isVenditaSeguita();

        if ($("#map").length > 0) {
            await InitMap(this.state.lottoId);
        }
        if ($("#mappoi").length > 0) {
            // Non blocchiamo l'inizializzazione della pagina in attesa dei POI:
            // il servizio Overpass pu� impiegare fino a diversi secondi (retry su pi� mirror),
            // quindi la mappa POI viene caricata in background senza rallentare gli altri script/handler.
            window.setTimeout(() => {
                InitMapPoi(this.state.lottoId).catch(error => {
                    console.error("Errore durante il caricamento della mappa POI:", error);
                });
            }, 100);
        }
        if ($("#mapserv").length > 0) {
            await InitServiziMappa();
        }

        this.initQRCode();
        this.initStickyButtonInfo();
        initAccordionDatiCatastali();

        this.registerFormContatti();

        return Promise.resolve();
    }

    // #region Form contatti
    private registerFormContatti(): void {
        const infoScheda: FormContattiConfig = {
            formSelector: "#form-contatti-scheda",
            openModalId: "openModalInfoScheda",
            submitButtonId: "submit-contatto-info-scheda",
            modalId: "ModalSchedaInfo",
            recaptchaKey: "infoscheda",
            endpoint: "Mailing/RichiestaContattoInfoScheda",
            fieldSuffix: "info-scheda",
            genericErrorMessage: "Errore durante l'invio del modulo di contatto",
            onOpen: (state) => {
                $("#lotto-id-title").text(state.lottoId);
            }
        };

        const richiediVisita: FormContattiConfig = {
            formSelector: "#form-richiedi-visita",
            openModalId: "openModalRichiediVisita",
            submitButtonId: "submit-richiedi-visita",
            modalId: "ModalSchedaRichiediVisita",
            recaptchaKey: "richiedivisita",
            endpoint: "Mailing/RichiestaVisita",
            fieldSuffix: "richiedi-visita",
            genericErrorMessage: "Errore durante l'invio del modulo di contatto di richiesta visita",
            onOpen: (state) => {
                let title = t("scheda.titleRichiediVisita");
                let subtitle = t("scheda.subtitleRichiediVisita") + " " + state.lottoId;
                if (state.isBeneMobile) {
                    title = t("scheda.titleRichiediVisione");
                    subtitle = t("scheda.subtitleRichiediVisione") + " " + state.lottoId;
                }
                $("#visita-title").text(title);
                $("#visita-subtitle").text(subtitle);
            }
        };

        new FormContattiManager(this.state, infoScheda).register();
        new FormContattiManager(this.state, richiediVisita).register();
    }
    // #endregion

    // #region Wiring pulsanti
    private wireButtons(): void {
        $(".btnDownloadDoc").on("click", (e) => {
            e.preventDefault();
            if (this.state.userInfo?.isAuthenticated && this.state.userInfo?.anagraficaId) {
                const userId = parseInt(this.state.userInfo.anagraficaId);
                const docId = $(e.currentTarget).data("id") as string;
                handleDownloadDoc(docId, userId);
            } else {
                gotoLogin(window.location.href);
            }
        });

        this.wireAuthenticatedNav("#btnGestisciOfferta", () => `/offerta-asta-dinamica-${this.state.venditaId}`);
        this.wireAuthenticatedNav("#btnMonitoraOfferte", () => `/monitora-vendita-${this.state.venditaId}`);
        this.wireAuthenticatedNav("#btnFaiUnOfferta", () => `/offerta-asta-dinamica-${this.state.venditaId}`);

        this.wireAuthenticatedNav("#btnGestisciOffertaAT", () => `/stato-asta-telematica-${this.state.IdAstaTelematica}`);
        this.wireAuthenticatedNav("#btnPartecipaAT", () => `/domanda-partecipazione-asta-telematica-${this.state.venditaId}`, true);
        this.wireAuthenticatedNav("#btnMonitoraAT", () => `/monitora-asta-telematica-${this.state.IdAstaTelematica}`);

        $("#seguiVendita").on("click", async (e) => {
            e.preventDefault();
            if (!this.state.userInfo?.isAuthenticated || !this.state.userInfo?.anagraficaId) {
                gotoLogin(window.location.href);
                return;
            }
            const userId = parseInt(this.state.userInfo.anagraficaId);
            const response = await AddVenditaSeguita(userId, this.state.lottoId);
            if (response > 0) {
                $("#seguiVendita").addClass("d-none");
                $("#venditaSeguita").removeClass("d-none");
            } else {
                UI.confirmOneButton("", "Errore durante il salvataggio della vendita seguita:");
            }
        });

        $("#venditaSeguita").on("click", async (e) => {
            e.preventDefault();
            if (!this.state.userInfo?.isAuthenticated || !this.state.userInfo?.anagraficaId) {
                gotoLogin(window.location.href);
                return;
            }
            const userId = parseInt(this.state.userInfo.anagraficaId);
            const response = await RemoveVenditaSeguita(userId, this.state.lottoId);
            if (response.size === 0) {
                $("#seguiVendita").removeClass("d-none");
                $("#venditaSeguita").addClass("d-none");
            } else {
                UI.confirmOneButton("", "Errore durante la cancellazione della vendita seguita:");
            }
        });

        $("#tel-agenzia").on("click", async (e) => {
            e.preventDefault();
            const $this = $(e.currentTarget);
            const telefono = $this.data("telefono") as string;
            const agenziaId = $this.data("agenzia-id") as number;
            if (!telefono) return;

            const isMobile = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
            try {
                await this.trackContattoTelefonico({
                    LottoId: this.state.lottoId,
                    VenditaId: this.state.venditaId,
                    AgenziaId: agenziaId,
                    UserId: this.state.userInfo?.anagraficaId || null,
                    NumeroTelefono: telefono,
                    IsMobileDevice: isMobile
                });
            } catch (error) {
                console.error("Errore tracking telefono:", error);
            }
            $("#tel-agenzia-text").text(telefono);
            $this.off("click");
            $this.css("cursor", "default");
        });

        $(".btn-copy-link").on("click", async (e) => {
            e.preventDefault();
            await this.copyLinkToClipboard();
        });
        $(".btn-facebook").on("click", async (e) => {
            e.preventDefault();
            await this.shareOnFacebookPage();
        });
    }

    private wireAuthenticatedNav(selector: string, urlFactory: () => string, showButtonLoader = false): void {
        let navigating = false;
        const $button = $(selector);
        const resetLoading = () => {
            navigating = false;
            $button.removeClass("disabled").removeAttr("aria-disabled aria-busy");
            $button.find("[data-navigation-loader]").remove();
        };
        if (showButtonLoader) {
            // Ripristina il pulsante anche tornando alla scheda dalla cache del browser.
            window.addEventListener("pageshow", resetLoading);
        }
        $button.on("click", (e) => {
            e.preventDefault();
            if (navigating) return;
            if (showButtonLoader) {
                navigating = true;
                $button.addClass("disabled").attr({ "aria-disabled": "true", "aria-busy": "true" });
                $button.prepend('<span data-navigation-loader class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>');
            }
            try {
                if (this.state.userInfo?.isAuthenticated && this.state.userInfo?.anagraficaId) {
                    window.location.href = urlFactory();
                } else {
                    gotoLogin(window.location.href);
                }
            } catch (error) {
                if (showButtonLoader) resetLoading();
                throw error;
            }
        });
    }

    private async trackContattoTelefonico(data: {
        LottoId: number;
        VenditaId: number;
        AgenziaId: number;
        UserId: number | null;
        NumeroTelefono: string;
        IsMobileDevice: boolean;
    }): Promise<void> {
        const url = `${window.BaseUrlWebApi}Tracing/ContattoTelefonico`;
        await fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=utf-8" },
            body: JSON.stringify(data)
        });
    }
    // #endregion

    // #region Vendita seguita
    private async isVenditaSeguita(): Promise<void> {
        if (!this.state.userInfo?.isAuthenticated || !this.state.userInfo?.anagraficaId) {
            return;
        }
        try {
            const isSeguita = await this.getVenditaSeguita();
            if (isSeguita) {
                $("#seguiVendita").addClass("d-none");
                $("#venditaSeguita").removeClass("d-none");
            }
        } catch (error) {
            console.error("Errore durante il controllo della vendita seguita:", error);
            UI.confirmOneButton("", "Errore durante il controllo della vendita seguita");
        }
    }

    private getVenditaSeguita(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            $.ajaxWithCredentials({
                url: window.BaseUrlWebApi + "VenditaSeguita/IsVenditaSeguita",
                method: "GET",
                data: { lottoId: this.state.lottoId, anagraficaId: this.state.userInfo?.anagraficaId }
            })
                .done((data: any) => resolve(data))
                .fail((jqXHR: any, textStatus: string, errorThrown: string) => reject({ jqXHR, textStatus, errorThrown }));
        });
    }
    // #endregion

    // #region QR Code
    private async initQRCode(): Promise<void> {
        if ($("#qrcode").length === 0) return;
        const qrcodeElement = document.getElementById("qrcode");
        if (!qrcodeElement) return;

        const blockchainPath = $("#qrcode").closest("a").attr("href");
        if (!blockchainPath) return;

        try {
            const canvas = document.createElement("canvas");
            qrcodeElement.appendChild(canvas);
            await QRCode.toCanvas(canvas, blockchainPath, {
                width: 200,
                margin: 2,
                color: { dark: "#000000", light: "#FFFFFF" }
            });
        } catch (error) {
            console.error("Errore durante la generazione del QR Code:", error);
        }
    }
    // #endregion

    // #region Image Comparison Slider
    private initImageComparisonSliders(): void {
        const comparisonSliders = $(".comparison-slider");
        if (comparisonSliders.length === 0) return;

        comparisonSliders.each((_, el) => this.waitForImagesToLoad($(el)));
        $(window).on("resize", () => {
            comparisonSliders.each((_, el) => this.updateSliderImageWidth($(el)));
        });
        this.initTabSwitchHandler();
    }

    private waitForImagesToLoad(slider: JQuery<HTMLElement>): void {
        const images = slider.find("img");
        const total = images.length;
        let loaded = 0;
        images.each((_, img) => {
            const done = () => {
                loaded++;
                if (loaded === total) this.initComparisonSlider(slider);
            };
            if ((img as HTMLImageElement).complete) done();
            else $(img).on("load", done);
        });
    }

    private initComparisonSlider(slider: JQuery<HTMLElement>): void {
        this.updateSliderImageWidth(slider);
        this.enableSliderDrag(slider.find(".divider"), slider.find(".resize"), slider);
    }

    private updateSliderImageWidth(slider: JQuery<HTMLElement>): void {
        const sliderWidth = slider.width() + "px";
        slider.find(".resize img").css({ width: sliderWidth });
    }

    private enableSliderDrag(
        dragElement: JQuery<HTMLElement>,
        resizeElement: JQuery<HTMLElement>,
        container: JQuery<HTMLElement>
    ): void {
        container.on("selectstart dragstart", (e) => { e.preventDefault(); return false; });
        container.find("img").attr("draggable", "false");

        dragElement.on("mousedown touchstart", (e) => {
            e.preventDefault();
            dragElement.addClass("draggable");
            resizeElement.addClass("resizable");

            const event = e as JQuery.MouseDownEvent | JQuery.TouchStartEvent;
            const startX = (event as JQuery.MouseDownEvent).pageX ||
                (event as any).originalEvent.touches[0].pageX;
            const dragWidth = dragElement.outerWidth() || 0;
            const posX = (dragElement.offset()?.left || 0) + dragWidth - startX;
            const containerOffset = container.offset()?.left || 0;
            const containerWidth = container.outerWidth() || 0;
            const minLeft = containerOffset + 10;
            const maxLeft = containerOffset + containerWidth - dragWidth - 10;

            const onEnd = () => {
                dragElement.removeClass("draggable");
                resizeElement.removeClass("resizable");
            };

            dragElement.parents().on("mousemove touchmove", (moveEvent) => {
                moveEvent.preventDefault();
                const mEvent = moveEvent as JQuery.MouseMoveEvent | JQuery.TouchMoveEvent;
                const moveX = (mEvent as JQuery.MouseMoveEvent).pageX ||
                    (mEvent as any).originalEvent.touches[0].pageX;
                let leftValue = moveX + posX - dragWidth;
                if (leftValue < minLeft) leftValue = minLeft;
                else if (leftValue > maxLeft) leftValue = maxLeft;

                const widthValue = ((leftValue + dragWidth / 2 - containerOffset) * 100 / containerWidth) + "%";
                $(".draggable").css("left", widthValue).on("mouseup touchend touchcancel", onEnd);
                $(".resizable").css("width", widthValue);
            }).on("mouseup touchend touchcancel", onEnd);
        }).on("mouseup touchend touchcancel", () => {
            dragElement.removeClass("draggable");
            resizeElement.removeClass("resizable");
        });
    }

    private initTabSwitchHandler(): void {
        const tabLinks = document.querySelectorAll('a[data-bs-toggle="tab"]');
        tabLinks.forEach((tab) => {
            tab.addEventListener("shown.bs.tab", () => {
                document.querySelectorAll(".comparison-slider").forEach((slider) => {
                    if ((slider as HTMLElement).offsetParent !== null) {
                        const sliderWidth = (slider as HTMLElement).offsetWidth + "px";
                        slider.querySelectorAll(".resize img").forEach((img) => {
                            (img as HTMLElement).style.width = sliderWidth;
                        });
                    }
                });
            });
        });
    }
    // #endregion

    // #region Sticky button info (mobile)
    private initStickyButtonInfo(): void {
        const buttonInfo = document.querySelector(".buttoninfo") as HTMLElement;
        if (!buttonInfo) return;

        const update = () => {
            const isMobile = window.innerWidth < 992;
            const isScrolled = window.scrollY > 0;
            if (isMobile && isScrolled) buttonInfo.classList.add("buttoninfo-sticky");
            else buttonInfo.classList.remove("buttoninfo-sticky");
        };
        update();
        window.addEventListener("resize", update);
        window.addEventListener("scroll", update, { passive: true });
    }
    // #endregion

    // #region Share
    private async copyLinkToClipboard(): Promise<void> {
        const currentUrl = window.location.href;
        try {
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(currentUrl);
                UI.confirmOneButton("", "Link copiato negli appunti!");
            } else {
                this.fallbackCopyToClipboard(currentUrl);
            }
        } catch (error) {
            console.error("Errore copia link:", error);
            this.fallbackCopyToClipboard(currentUrl);
        }
    }

    private fallbackCopyToClipboard(text: string): void {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        textarea.style.top = "0";
        textarea.style.left = "0";
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try {
            const successful = document.execCommand("copy");
            if (successful) {
                UI.confirmOneButton("", "Link copiato negli appunti!");
            } else {
                UI.confirmOneButton("", "Impossibile copiare il link. Copia manualmente l'URL dalla barra degli indirizzi.");
            }
        } catch (error) {
            console.error("Errore fallback copia:", error);
            UI.confirmOneButton("", "Impossibile copiare il link. Copia manualmente l'URL dalla barra degli indirizzi.");
        } finally {
            document.body.removeChild(textarea);
        }
    }

    private async shareOnFacebookPage(): Promise<void> {
        try {
            const response: facebook.ShareDialogResponse = await shareOnFacebook(window.location.href, {});
            if (!response || !response.post_id) {
                return;
            }
        } catch (error) {
            console.error("Errore condivisione Facebook:", error);
            const errorMessage = error instanceof Error ? error.message : "Errore sconosciuto";
            if (errorMessage === "Facebook SDK non disponibile") {
                UI.confirmOneButton("", "Impossibile connettersi a Facebook. Riprova tra qualche istante.");
            } else {
                UI.confirmOneButton("", "Si è verificato un errore durante la condivisione su Facebook.");
            }
        }
    }
    // #endregion
}

